import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Pane, Heading, Button } from 'evergreen-ui';

import { createShop } from '../actions/ShopActions';
import ShopForm from '../components/ShopForm';
import InfoBlock from '../../common/InfoBlock/InfoBlock';
import Configuration from '../Config';

const validation = Configuration.Validations.shop;
const defaultValues = Configuration.Defaults.createShop;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CreateShop extends Component {
    handleSave = (values) => {
        this.props.dispatch(createShop(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/shops">
                            <Button iconBefore="arrow-left" intent="none">
                                Înapoi la lista magazinelor
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Magazin nou
                    </Heading>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <ShopForm
                            isEdit={false}
                            initialValues={defaultValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}
                        />
                    </InfoBlock>
                </Pane>
            </Pane>
        );
    }
}

function mapStateToProps(state) {
    return {
        errors: state.shops.errors.type === 'validation' 
            ? mapValidationErrors(state.shops.errors.fields) 
            : []
    };
}

export default connect(mapStateToProps)(CreateShop);
